"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const systolicBloodPressure = schema_1.Schema.number()
    .unit("Hgmm")
    .integer()
    .min(0)
    .max(300);
const diastolicBloodPressure = schema_1.Schema.number()
    .unit("Hgmm")
    .integer()
    .min(0)
    .max(300);
const heartRate = schema_1.Schema.number().unit("1/min").integer().min(0).max(300);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ systolicBloodPressure, diastolicBloodPressure, heartRate })
    .interpretation({ vocab: "ktx", code: "blood_pressure" });
